// extracted by mini-css-extract-plugin
export default {"btn":"DeleteCat_btn__Aub8o"};